<template>
  <div class="container sv047">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>ご返済について</HeadingOne>

    <p>
      スマートフォン・パソコンがあれば簡単にお手続きが可能！ご返済方法やご返済金額などご返済に関する内容についてこちらでご案内します。
    </p>

    <section class="_mb-md-120 _mb-sm-60">
      <HeadingTwo>ご返済金額</HeadingTwo>

      <ListGroup class="-normal _mb-md-60 _mb-sm-30">
        <ListItem class="-normal"
          >ご返済方式は、最終のお借り入れ時のご利用残高に応じてご返済金額が変動する「元利均等定額の借入時残高スライドリボルビング方式」です。</ListItem
        >
        <ListItem class="-normal"
          >毎月のご返済金額以上であれば、お客さまのご都合に合わせて、追加でご返済いただくことも可能です。</ListItem
        >
        <ListItem class="-normal"
          >ご返済は、1円単位となります。（セブン銀行スマホATMでご返済の場合は、1,000円単位）</ListItem
        >
      </ListGroup>
      <ChartBox>
        <ChartHeader>
          <ChartRow>
            <ChartData class="-justify-2">ご利用残高</ChartData>
            <ChartData class="-justify-2">毎月のご返済額</ChartData>
          </ChartRow>
        </ChartHeader>
        <ChartBody>
          <ChartRow>
            <ChartData class="-sp-left">100,000円以下</ChartData>
            <ChartData class="-sp-left">4,000円</ChartData>
          </ChartRow>
          <ChartRow>
            <ChartData class="-sp-left">100,001円～200,000円</ChartData>
            <ChartData class="-sp-left">8,000円</ChartData>
          </ChartRow>
          <ChartRow>
            <ChartData class="-sp-left">200,001円～400,000円</ChartData>
            <ChartData class="-sp-left">11,000円</ChartData>
          </ChartRow>
          <ChartRow>
            <ChartData class="-sp-left">400,001円～500,000円</ChartData>
            <ChartData class="-sp-left">13,000円</ChartData>
          </ChartRow>
          <ChartRow>
            <ChartData class="-sp-left">500,001円～600,000円</ChartData>
            <ChartData class="-sp-left">16,000円</ChartData>
          </ChartRow>
          <ChartRow>
            <ChartData class="-sp-left">600,001円～700,000円</ChartData>
            <ChartData class="-sp-left">18,000円</ChartData>
          </ChartRow>
          <ChartRow>
            <ChartData class="-sp-left">700,001円～800,000円</ChartData>
            <ChartData class="-sp-left">21,000円</ChartData>
          </ChartRow>
          <ChartRow>
            <ChartData class="-sp-left">800,001円～900,000円</ChartData>
            <ChartData class="-sp-left">23,000円</ChartData>
          </ChartRow>
          <ChartRow>
            <ChartData class="-sp-left">900,001円～1,000,000円</ChartData>
            <ChartData class="-sp-left">24,000円</ChartData>
          </ChartRow>
        </ChartBody>
      </ChartBox>

      <ListGroup class="-note">
        <ListItem class="-note"
          >ただし、最終返済月等、上記のご返済金額に満たない場合は、その金額がご返済金額となります。</ListItem
        >
      </ListGroup>
    </section>

    <section class="_mb-md-120 _mb-sm-60 repayment_date">
      <HeadingTwo id="section_01" name="section_01">ご返済日</HeadingTwo>

      <p>
        ご返済日は毎月26日*となります。<br />
        なお、ご返済日前にお客さまのご都合に合わせてご返済いただくことも可能です。<br />
        <small>* 金融機関休業日の場合は、翌営業日となります。</small>
      </p>

      <div class="title">資金に余裕のあるときは任意のご返済も可能です。</div>

      <p>
        毎月のご返済日以外にも、お客さまのご都合にあわせ任意の日にご返済いただけます。返済の方法は<router-link
          v-scroll-to="{ el: '#method', offset: -120 }"
          :to="{ path: '#method' }"
          class="-underline"
          >下記のご返済方法</router-link
        >をご選択いただけます。
      </p>
      <ListGroup class="-note _mb-30">
        <ListItem class="-note"
          >ご利用残高全額のご返済を希望されるお客さまは、ご返済いただける日付によってご返済金額が異なります。お手続きの前に必ず<BtnText
            router-name="sv036"
            class="-underline"
            >au PAY スマートローン 会員さま専用デスク</BtnText
          >までお問い合わせいただくようお願いいたします。</ListItem
        >
      </ListGroup>

      <NoticeBox class="-alert">
        <NoticeHeader>
          <h2 class="heading">【ご注意ください】</h2>
        </NoticeHeader>
        <NoticeBody>
          任意のご返済は、ご返済いただくタイミングにより次回のご返済分に充当される場合があります。詳しくは下記の各ご返済方法のページをご確認ください。
        </NoticeBody>
      </NoticeBox>
    </section>

    <section id="method" class="_mb-md-120 _mb-sm-60 repayment_method">
      <HeadingTwo>ご返済方法</HeadingTwo>
      <p class="_mb-20">
        ご返済方法は下記よりお選びいただけます。詳細は各ページをご確認ください。
      </p>
      <div class="row">
        <div class="col-md-6 col-12 _mb-20">
          <CardBox router-name="sv026">
            <CardHeader>
              <span class="img"
                ><img src="@/assets/images/sv/sv047/img01.gif"
              /></span>
              <span class="title">ご登録口座からのお引落し</span>
            </CardHeader>
          </CardBox>
        </div>
        <div class="col-md-6 col-12 _mb-20">
          <CardBox router-name="sv029">
            <CardHeader>
              <span class="img"
                ><img src="@/assets/images/sv/sv047/img03.gif"
              /></span>
              <span class="title">セブン銀行スマホATM</span>
            </CardHeader>
          </CardBox>
        </div>
        <div class="col-md-6 col-12">
          <CardBox router-name="sv027">
            <CardHeader>
              <span class="img"
                ><img src="@/assets/images/sv/sv047/img02.gif"
              /></span>
              <span class="title">指定口座へのお振込み</span>
            </CardHeader>
          </CardBox>
        </div>
      </div>
    </section>
    <section class="_mb-md-120 _mb-sm-60">
      <HeadingTwo>ご返済シミュレーション</HeadingTwo>
      <ListGroup>
        <ListItem
          >毎月のご返済額やご返済期間は、最終のお借り入れ時のご利用残高に応じて自動的に決定します。<br
            class="-pcnone"
          />毎月のご返済額やご返済期間について知りたい場合は、「ご返済シミュレーション」をお試しください。</ListItem
        >
      </ListGroup>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-normal" router-name="sv052">
          ご返済シミュレーションへ
        </BtnMain>
      </BtngroupSingle>
    </section>

    <CvBox class="_mb-md-120 _mb-sm-60" />

    <ContactBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import ContactBox from "@/components/box/ContactBox";
import CvBox from "@/components/box/CvBox";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
// import CardBody from '@/components/card/CardBody';
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
// import CardLink from '@/components/card/CardLink';
import ChartBox from "@/components/charts/ChartBox";
import ChartHeader from "@/components/charts/ChartHeader";
import ChartBody from "@/components/charts/ChartBody";
import ChartRow from "@/components/charts/ChartRow";
import ChartData from "@/components/charts/ChartData";
import BtnText from "@/components/button/BtnText";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";
import { isWebView } from "@/utils/UserAgent";

export default {
  name: "Sv047",
  components: {
    BreadcrumbGroup,
    BtnText,
    ChartData,
    ChartRow,
    ChartBody,
    ChartHeader,
    ChartBox,
    // CardLink,
    ListItem,
    ListGroup,
    // CardBody,
    CardHeader,
    CardBox,
    CvBox,
    ContactBox,
    BtnMain,
    BtngroupSingle,
    HeadingOne,
    HeadingTwo,
    NoticeBox,
    NoticeHeader,
    NoticeBody,
  },
  setup() {
    setMeta({
      title: "ご返済について",
      description:
        "au PAY スマートローンでのご返済方法についてご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "ご返済について",
          active: true,
        },
      ],
    };
  },
  mounted() {
    setTimeout(this.scrolleToHash, 300);
  },
  methods: {
    scrolleToHash() {
      if (this.$route.hash.match(/^#/)) {
        let id = this.$route.hash.replace(/^#/, "");
        let offset = this.isWebView()
          ? -10
          : -(document.getElementById(id).clientHeight * 3);
        this.$scrollTo(this.$route.hash, 400, {
          easing: "ease",
          offset: offset,
        });
      }
    },
    isWebView() {
      return isWebView();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.repayment_date {
  .title {
    font-size: 16px;
    padding-top: 30px;
    padding-bottom: 10px;
    margin-bottom: 15px;
    border-bottom: 1px solid #cccccc;
    @include mq-up(md) {
      font-size: 24px;
      padding-top: 30px;
      margin-bottom: 30px;
    }
  }
}
.repayment_method {
  .card-header {
    background-image: url("@/assets/images/icons/arrow-right-orange.svg");
    background-size: 8px auto;
    background-position: right 18px center;
    background-repeat: no-repeat;
    padding: 10px 20px !important;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @include mq-up(md) {
      padding: 10px 30px !important;
      background-position: right 32px center;
    }
    .img {
      display: inline-block;
      width: 35px;
      margin-right: 15px;
      > img {
        height: 35px;
        vertical-align: middle;
      }
      @include mq-up(md) {
        width: 48px;
        margin-right: 20px;
        > img {
          height: 48px;
        }
      }
    }
    .title {
      font-weight: normal;
    }
  }
}
</style>
